import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=237e7eb5&scoped=true&"
import script from "./DetailInfo.vue?vue&type=script&lang=ts&"
export * from "./DetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DetailInfo.vue?vue&type=style&index=0&id=237e7eb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e7eb5",
  null
  
)

export default component.exports